import React, { PureComponent } from 'react'
import TookanTeamInfoItem from './TookanTeamInfoItem'

class TookanTeamInfo extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectedPanel: 0,
    }
  }

  selectPanel = (selectedPanel) => () => {
    this.setState({
      selectedPanel,
    })
  }

  render() {
    const { selectedPanel } = this.state
    const { shopsList = {} } = this.props
    const { values = [] } = shopsList
    const shops = values || []

    return (
      <div>
        {shops.map((shop, index) => {
          return (
            <TookanTeamInfoItem
              key={index}
              shop={shop}
              index={index}
              selectedPanel={selectedPanel}
              selectPanel={this.selectPanel}
            />
          )
        }) || null}
      </div>
    )
  }
}

export default TookanTeamInfo



// WEBPACK FOOTER //
// ./src/components/Tookan/TookanTeamInfo.js